import React from 'react';

import cn from '@/helpers/utils/classNames';

const Spinner = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn('h-4 w-4 animate-spin rounded-full border-2 border-gray-300 !border-t-[#154734]', className)}
    ></div>
  );
};

export default Spinner;
